import React from 'react';

import './ModeSelector.scss';


interface IProps<T extends string> {
    options: readonly T[];
    currentSelection: T;
    setter: React.Dispatch<React.SetStateAction<T>>;
}

const ModeSelector = <T extends string>(props: IProps<T>) => {
    const { options, currentSelection, setter } = props

    return <div className='ModeSelector'>
        {
            options.map(option => {
                const set = () => { setter(option) };
                const selected = (option === currentSelection)
                return (
                    <button className='ModeButton' key={option} onClick={set} aria-pressed={selected} >
                        {option}
                    </button>
                )
            })
        }
    </div>
}

export default ModeSelector;